import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import AlreadyRegisteredWrapper from 'app/auth/components/onboarding/steps/shared/AlreadyRegisteredWrapper'
import { useOnboardingContext } from 'app/auth/components/onboarding/use-onboarding-context'
import { Box, Typography } from '@mui/material'
import { useApplicationName } from 'hooks/use-application-name'

const AlreadyRegisteredUserEmail = () => {
  const { t } = useTranslation()
  const { duplicationData } = useOnboardingContext()
  const { appName } = useApplicationName()
  const email = useMemo(() => duplicationData?.loginEmail, [duplicationData?.loginEmail])

  return (
    <AlreadyRegisteredWrapper>
      <Box my={2}>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageUserEmail1', { email, appName })}
        </Typography>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageUserEmail2')}
        </Typography>
      </Box>
    </AlreadyRegisteredWrapper>
  )
}

export default AlreadyRegisteredUserEmail
